export default "__VITE_ASSET__D9Ket$IO__"